export type MenuGroup =
  | "home"
  | "customerData"
  | "connect"
  | "developer"
  | "organization"
  | "lab";

/** The order groups appear in the side menu. */
export const MENU_GROUP_ORDER: ReadonlyArray<MenuGroup> = [
  "home",
  "customerData",
  "connect",
  "developer",
  "organization",
  "lab",
];

/**
 * Splits visible menu items into their groups, in `MENU_GROUP_ORDER`, keeping
 * each group's item order. Groups with no visible item are left out, so an
 * organization without, say, Vibe Lab never sees an empty "Labs" heading.
 */
export const groupMenuItems = <TItem extends { group: MenuGroup }>(
  items: ReadonlyArray<TItem>,
): Array<{ group: MenuGroup; items: Array<TItem> }> =>
  MENU_GROUP_ORDER.map((group) => ({
    group,
    items: items.filter((item) => item.group === group),
  })).filter((section) => section.items.length > 0);
